import type { ProjectAgent } from "@/api/agents";
import { resolveDenkerProjectAgent } from "@/lib/denker-composer-agent";
import { useAgentStore } from "@/stores/agent-store";
import { useProjectStore } from "@/stores/project-store";
import { denkerAvatarColor } from "./use-denker-avatar-color";

/** Denker's name, and its avatar seed until its template is known. */
export const DENKER_AGENT_NAME = "Denker";

/** The avatar seed the user set for Denker in Settings, else its name. */
export function denkerAvatarSeed(agents: ProjectAgent[]): string {
  return (
    resolveDenkerProjectAgent(agents)?.template_avatar_seed || DENKER_AGENT_NAME
  );
}

/**
 * Denker's own avatar: the face the user set in Settings, on the colour of
 * the project the work is in. Every Denker avatar (helpers, sub-agents, jobs
 * and chats alike) draws from here; each part subscribes to one string.
 */
export function useDenkerAvatar(projectId: string | null | undefined): {
  seed: string;
  backgroundColor: string | undefined;
} {
  const seed = useAgentStore((state) => denkerAvatarSeed(state.agents));
  const backgroundColor = useProjectStore((state) =>
    denkerAvatarColor(
      DENKER_AGENT_NAME,
      projectId
        ? state.projects.find((project) => project.id === projectId)
        : null,
    ),
  );
  return { seed, backgroundColor };
}
